import { type ValidationError } from "../types";

export function isValidationError(error: unknown): error is ValidationError {
  return (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    "errors" in error &&
    typeof error.errors === "object"
  );
}

export const isRecordObject = (
  input: unknown,
): input is Record<string, unknown> => {
  return typeof input === "object" && input !== null && !Array.isArray(input);
};
